import React from "react";
import styled from "styled-components";

const Asterisk = styled.span`
  color: ${({ theme }) => theme.colors.error};
`;

function CustomLabel({ label, required }) {
  return (
    <span>
      {label} {required && <Asterisk>*</Asterisk>}
    </span>
  );
}

export default CustomLabel;
